import { forwardRef, MouseEvent } from 'react';
import { IconButton, IconButtonProps } from '@mui/material';

import useMenu from './useMenu';

export const MenuIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ children, onClick, ...rest }, ref) => {
    const { onOpen, open } = useMenu();

    return (
      <IconButton
        aria-expanded={open}
        aria-haspopup='menu'
        {...rest}
        onClick={(e: MouseEvent<HTMLButtonElement>) => {
          onClick?.(e);
          onOpen(e);
        }}
        ref={ref}
      >
        {children}
      </IconButton>
    );
  }
);
